import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormsModule, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonicModule, ToastController } from "@ionic/angular";
import { Subject, takeUntil } from 'rxjs';
import { CouponFlows } from "src/app/flows/coupon.flows";
import { calculateCouponEligibleAmount, Coupon } from 'src/app/shared-lib/domains/coupon';
import { ProductType } from 'src/app/shared-lib/domains/product';
import { WalletService } from "src/app/shared-lib/domains/wallet";
import { DiscountType } from 'src/app/shared-lib/global/models';
import { OrderStateService } from 'src/app/shared/order-state.service';
import { OrderService } from 'src/app/shared/order.service';
import { CartService } from "../../shared/cart.service";

export interface CouponResp extends Coupon {
  message: string,
  label: string;
}

@Component({
  selector: 'app-add-coupon',
  templateUrl: './add-coupon.component.html',
  styleUrls: ['./add-coupon.component.scss'],
  imports: [CommonModule, FormsModule, IonicModule],
  standalone: true
})
export class AddCouponComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('inputCoupon', { static: false }) ionInput: any;
  @Output() applyCoupon = new EventEmitter<any>();
  @Input() orderForm: UntypedFormGroup;
  @Input() coupon;
  @Input() freeShipping: boolean = false;
  @Input() disabled: boolean;
  edit = true;
  isValidating = false;

  cuponCode = '';
  errorMessage = '';
  titleCoupon = '';
  discountType = DiscountType;

  private componetDestroyed = new Subject();

  order = null;

  constructor(
    private couponFlows: CouponFlows,
    public cartService: CartService,
    public orderStateService: OrderStateService,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private walletService: WalletService,
    private toastController: ToastController
  ) {
  }

  ngOnInit() {
    this.orderStateService.order$
      .pipe(takeUntil(this.componetDestroyed))
      .subscribe((order) => {
        this.order = order;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    const currentcoupon: SimpleChange = changes.coupon;
    if (currentcoupon) {
      this.titleCoupon = "";
      if (currentcoupon.currentValue) {
        this.cuponCode = currentcoupon.currentValue.code;
        this.titleCoupon = currentcoupon.currentValue.title;
      } else {
        this.cuponCode = null;
      }
    }
  }

  ngAfterViewInit(): void {
  }

  async apply(value?) {

    if (this.isValidating) return;

    this.titleCoupon = "";

    const email = this.order.email;
    this.isValidating = true;
    this.couponFlows.validateCoupon({
      code: this.cuponCode.toUpperCase(),
      email,
      cartAmount: calculateCouponEligibleAmount(this.cartService.cart.price.totalAmt, this.cartService.cart.shipping.price.amt)
    })
      .then((resp: CouponResp) => {//resp:Coupon

        this.edit = !resp.valid;
        if (!resp.valid) {

          this.errorMessage = resp.label;

          resp = null;
        } else {
          this.edit = false;
          this.titleCoupon = resp.title;
          this.errorMessage = '';
        }

        this.applyCoupon.emit(resp);
      })
      .catch(err => {

        this.errorMessage = 'Debes escribir tu dirección de correo o iniciar sesión primero';
      })
      .finally(() => {
        this.isValidating = false;
      });
  }

  remove() {
    this.edit = true;
    this.cuponCode = null;
    this.titleCoupon = "";
    this.applyCoupon.emit(null);

  }

  add() {
    this.edit = true;
    setTimeout(() => {
      this.ionInput.setFocus();
    }, 300);
  }

  onKeyPress(event) {
    return true;

  }

  onInputChange() {
    const v = this.cuponCode.split('').map(c => /^[0-9a-zA-Z\u00f1\u00d1]$/.test(c) ? c : '').join('');
    setTimeout(() => {
      this.cuponCode = v;
    }, 10);
  }

  public validate(code) {
    this.cuponCode = code?.toUpperCase();
    if (this.cuponCode) {
      this.apply();
    } else {
      this.applyCoupon.emit(null);
    }
  }

  getCannotUseCouponMsg() {
    const hasWalletBonus = this.cartService.cart.items.find(item => item.product.type === ProductType.WALLETBONUS);
    const hastPrintProduct = this.cartService.cart.items.find(item => item.product.type === ProductType.PRINT);
    const hasCommissionableProduct = this.cartService.cart.items.find(item => !!item.product.commissionable);

    const hasWallet = this.walletService.wallet.balance > 0 && this.cartService.discountWallet;

    if (!hastPrintProduct && !hasCommissionableProduct) {
      return 'Solo puedes aplicar cupones de descuento sobre impresiones';
    } else {
      return 'El uso de cupones no es compatible con el uso del bono monedero';
    }
  }
}
